module.exports = __webpack_public_path__ + "img/big_11B01_orange.553dc2e8.png";